<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <form action="post" @submit.prevent="saveContact" :class="{ 'was-validated': submitted }">
      <div class="form-group">
        <label for="Firstname">Förnamn</label>
        <input type="text" class="form-control" id="Firstname" v-model="contact.Firstname" required>
      </div>

      <div class="form-group">
        <label for="Lastname">Efternamn</label>
        <input type="text" class="form-control" id="Lastname" v-model="contact.Lastname" required>
      </div>

      <div class="form-group">
        <label for="Position">Position</label>
        <input type="text" class="form-control" id="Position" v-model="contact.Position">
      </div>

      <div class="form-group">
        <label for="Phone">Telefon</label>
        <input type="tel" class="form-control" id="Phone" v-model="contact.Phone">
      </div>

      <div class="form-group">
        <label for="Mobile">Mobil</label>
        <input type="tel" class="form-control" id="Mobile" v-model="contact.Mobile">
      </div>

      <div class="form-group">
        <label for="Email">Epost</label>
        <input type="email" class="form-control" id="Email" v-model="contact.Email">
      </div>
      <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
      <button type="submit" class="btn btn-primary" @click="submitted = true">Spara</button>
    </form>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  data () {
    return {
      id: null,
      contact: {},
      submitted: false,
      error: ''
    }
  },

  created () {
    this.id = this.$route.params.id

    appService.getContact(this.id)
    .then((data) => { this.contact = data })
  },

  methods: {
    saveContact () {
      appService.updateContact(this.id, this.contact)
      .then(() => { this.$router.go(-1) })
      .catch(() => { this.error = 'Det gick inte att spara.' })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/ContactEdit.vue